import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../css/Showcase.css";
import RequestQuoteButton from "../../RequestButton/js/RequestQuoteButton";

const Showcase = ({ items = [] }) => {
  const [active, setActive] = useState(0);

  return (
    <section className="showcase">
      <div className="showcaseTrack">
        {items.map((item, i) => {
          const isActive = i === active;
          return (
            <article
              key={item.id}
              className={`scPanel ${isActive ? "isActive" : ""}`}
              style={{
                backgroundImage: `linear-gradient(180deg, rgba(12,12,13,0.55), rgba(12,12,13,0.88)), url("${
                  item.bg || item.image
                }")`,
              }}
              onClick={() => setActive(i)}
            >
              <button
                type="button"
                className="scTab"
                onClick={(e) => {
                  e.stopPropagation();
                  setActive(i);
                }}
              >
                <span className="scIndex">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="scTabTitle">{item.title}</span>
              </button>

              <div className="scContent">
                <div className="scMedia">
                  <img src={item.image} alt={item.title} loading="lazy" />
                </div>
                <div className="scBody">
                  <span className="scKicker">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <h3 className="scTitle">{item.title}</h3>
                  <p className="scIntro">{item.intro}</p>
                  {item.list && item.list.length > 0 && (
                    <ul className="scList">
                      {item.list.map((entry) => (
                        <li key={entry}>{entry}</li>
                      ))}
                    </ul>
                  )}
                  <div className="scCtas">
                    <Link to="/portfolio" className="scWorkLink">
                      <button type="button" className="scWorkBtn">
                        View our work
                      </button>
                    </Link>
                    <RequestQuoteButton />
                  </div>
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default Showcase;
